import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";

import SSHKeyForm from "../../components/account/SSHKeyForm.jsx";
import withBasicForm from "../../components/forms/withBasicForm.js";

const SSHKeyBasicForm = withBasicForm(SSHKeyForm);

class SSHKeyTab extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    violationErrors: PropTypes.object
  };

  // -- RENDER -- //

  render() {
    return <SSHKeyBasicForm {...this.props} />;
  }
}

export default SSHKeyTab;
